export default {"src":"/_next/static/media/cmlT4.807b59f4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};